import { ENDPOINT_IFP_APPLICATION_ACTION, IfpApplicationAction } from '@shared/sec-loans'
import { GetDataStep } from '@ui-common/steps/GetDataStep/GetDataStep'
import { callEndpoint } from '@ui-common/utils/http/client'
import { JSX } from 'react'
import { useIntl } from 'react-intl'
import { ActorRef, Snapshot } from 'xstate'

export const CancelApplicationStep = (props: {
  parentService: ActorRef<Snapshot<unknown>, { type: 'APPLICATION_CANCELLED' }>
  applicationId: string
  onAbort?: () => unknown
}): JSX.Element => {
  const intl = useIntl()

  const { parentService, applicationId } = props

  return (
    <GetDataStep
      getDataCallback={() => {
        return callEndpoint(ENDPOINT_IFP_APPLICATION_ACTION, {
          pathParams: { applicationId, action: IfpApplicationAction.Cancel },
        })
      }}
      heading={intl.formatMessage({ id: 'common-loading' })}
      onAbort={props.onAbort}
      callbacks={{ proceed: () => parentService.send({ type: 'APPLICATION_CANCELLED' }) }}
    />
  )
}

export default CancelApplicationStep
